import { keepPreviousData, queryOptions } from "@tanstack/react-query";

import { useApi } from "@/api/hooks/useApi";
import { commonAPIDataSelector } from "@/helpers/Network/selectors";
import { QUERY_KEYS } from "@/query-keys";
import type { ApiQueryParams } from "@/types/api-types";

type ActiveSurveyQuery = ApiQueryParams<"getAutomatedSurveysV1">;

export const useAutomatedSurveyQueries = () => {
  const api = useApi();

  return {
    list: (query: ActiveSurveyQuery) =>
      queryOptions({
        queryKey: QUERY_KEYS.AUTOMATED_SURVEY_LIST(query),
        queryFn: () => api.getAutomatedSurveysV1(query),
        select: commonAPIDataSelector,
        placeholderData: keepPreviousData,
        staleTime: 5000,
      }),

    details: (id: string) =>
      queryOptions({
        queryKey: QUERY_KEYS.AUTOMATED_SURVEY_DETAILS(id),
        queryFn: () => api.getAutomatedSurveysDetailsV1(id),
        select: commonAPIDataSelector,
      }),

    activeList: (id: string, query: ActiveSurveyQuery) =>
      queryOptions({
        queryKey: QUERY_KEYS.AUTOMATED_SURVEY_ACTIVE_LIST(id, query),
        queryFn: () => api.getAutomatedSurveysActiveDetailsV1(id, query),
        select: commonAPIDataSelector,
        placeholderData: keepPreviousData,
        staleTime: 5000,
      }),
  };
};
